import { Input } from "@ember/component";
import { htmlSafe } from "@ember/template";
import DButton from "discourse/components/d-button";
import InputTip from "discourse/components/input-tip";
import PasswordField from "discourse/components/password-field";
import TogglePasswordMask from "discourse/components/toggle-password-mask";
import bodyClass from "discourse/helpers/body-class";
import icon from "discourse/helpers/d-icon";
import hideApplicationSidebar from "discourse/helpers/hide-application-sidebar";
import valueEntered from "discourse/helpers/value-entered";
import { i18n } from "discourse-i18n";

export default <template>
  {{bodyClass "admin-invite-page"}}
  {{hideApplicationSidebar}}

  <section>
    <div class="container invites-show clearfix">
      <div class="login-welcome-header">
        <h1 class="login-title">{{@controller.welcomeTitle}}</h1>
        <img src={{@controller.wavingHandURL}} alt class="waving-hand" />
      </div>

      <div class="col-form invite-form">
        <p>{{htmlSafe @controller.yourEmailMessage}}</p>
        <form>

          <div class="input username-input input-group">
            <Input
              @type="email"
              @value={{@controller.accountUsername}}
              name="username"
              autofocus="autofocus"
              id="new-account-username"
              class={{valueEntered @controller.accountUsername}}
            />
            <label class="alt-placeholder" for="new-account-username">{{i18n
                "user.username.title"
              }}</label>
            {{#if @controller.usernameErrorMessage}}
              <div class="tip bad">{{@controller.usernameErrorMessage}}</div>
            {{/if}}
            <div class="instructions">{{i18n
                "user.username.instructions"
              }}</div>
          </div>

          <div class="input name-input input-group">
            <Input
              @type="name"
              @value={{@controller.accountName}}
              name="name"
              autofocus="autofocus"
              id="new-account-name"
              class={{valueEntered @controller.accountName}}
            />
            <label class="alt-placeholder" for="new-account-name">{{i18n
                "invites.name_label"
              }}</label>
            <div class="instructions">{{@controller.nameInstructions}}</div>
          </div>

          <div class="input password-input input-group">
            <PasswordField
              @value={{@controller.accountPassword}}
              type={{if @controller.maskPassword "password" "text"}}
              @capsLockOn={{@controller.capsLockOn}}
              @id="new-account-password"
              class={{valueEntered @controller.accountPassword}}
            />
            <label class="alt-placeholder" for="new-account-password">{{i18n
                "invites.password_label"
              }}</label>
            <InputTip @validation={{@controller.passwordValidation}} />
            <div class="instructions">
              {{@controller.passwordValidationHelper.passwordInstructions}}
              <div
                class="caps-lock-warning
                  {{unless @controller.capsLockOn 'invisible'}}"
              >
                {{icon "triangle-exclamation"}}
                {{i18n "login.caps_lock_warning"}}
              </div>
              <TogglePasswordMask
                @maskPassword={{@controller.maskPassword}}
                @togglePasswordMask={{@controller.togglePasswordMask}}
              />
            </div>
          </div>

          <DButton
            @action={{@controller.submit}}
            @label="admin_invite.save"
            @disabled={{@controller.submitDisabled}}
            @type="submit"
            id="accept-admin-invite-btn"
            class="btn-primary"
          />
        </form>
      </div>
    </div>
  </section>
</template>
